import React from 'react';
import ReactDOM from 'react-dom';

import type { Initializer } from 'common/types/initializers';
import Wahanda from 'common/wahanda';
import get from 'lodash/get';
import { Provider } from 'react-redux';
import { track } from 'src/tracking/trackingService';

import { CustomerFormDialog } from './container';
import storeBuilder from 'reduxStore/store';

const container = Wahanda.Dialogs.getReactContainer();
const store = storeBuilder();
interface Params {
  id?: number;
  customerData?: object;
  fieldToFocus?: string;
}

function destroy(target) {
  ReactDOM.unmountComponentAtNode(target);
}

const onClose = () => {
  destroy(container);
};
const onSubmit = ({ notes_edited }: { notes_edited: boolean }) => {
  track('clients.client_list.edit_client_modal.edited', {
    notes_edited: notes_edited ? 'true' : 'false',
  });
  onClose();
};

export const CustomerFormDialogInitializer = (params: Params): Initializer => ({
  destroy: () => ReactDOM.unmountComponentAtNode(container),
  render: () => {
    ReactDOM.render(
      <Provider store={store}>
        <CustomerFormDialog
          customerData={get(params, 'customerData')}
          customerId={get(params, 'id')}
          fieldToFocus={get(params, 'fieldToFocus')}
          onClose={onClose}
          onSubmit={onSubmit}
        />
      </Provider>,
      container,
    );
  },
});
